import { getUploadCdnBase } from './adminAssetUploadStore';

export const PLUGIN_RESOURCE_PREFIX = 'share/plugins/';

export function getPluginTrackingDirectoryUrl(): string {
  return `${getUploadCdnBase()}share/plugins`;
}

const PLUGIN_CLOUDFRONT_INVALIDATION_URL_PRODUCTION =
  'https://us-east-1.console.aws.amazon.com/cloudfront/v4/home?region=us-east-1#/distributions/E2ZO95UDC9SBYA/invalidations/details/IECIYI419GGWZM5F2SMPVCORND';

const PLUGIN_CLOUDFRONT_INVALIDATION_URL_STAGING =
  'https://us-east-1.console.aws.amazon.com/cloudfront/v4/home?region=us-east-1#/distributions/ECHZQO0IZSWSI/invalidations/details/I1HG4YB5H7H8FLNRNQGW0XLT5S';

export function getPluginCloudfrontInvalidationUrl(): string {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  return env === ''
    ? PLUGIN_CLOUDFRONT_INVALIDATION_URL_PRODUCTION
    : PLUGIN_CLOUDFRONT_INVALIDATION_URL_STAGING;
}

export type PluginTrackingEntry = {
  fileName: string;
  unrealVersion: string;
  platform: 'Windows' | 'macOS';
};

export const PLUGIN_TRACKING_ENTRIES: PluginTrackingEntry[] = [
  {
    fileName: 'cartwheel-unreal-ue56-windows.zip',
    unrealVersion: '5.6',
    platform: 'Windows',
  },
  {
    fileName: 'cartwheel-unreal-ue57-windows.zip',
    unrealVersion: '5.7',
    platform: 'Windows',
  },
  {
    fileName: 'cartwheel-unreal-ue58-windows.zip',
    unrealVersion: '5.8',
    platform: 'Windows',
  },
  {
    fileName: 'cartwheel-unreal-ue56-macos.zip',
    unrealVersion: '5.6',
    platform: 'macOS',
  },
  {
    fileName: 'cartwheel-unreal-ue57-macos.zip',
    unrealVersion: '5.7',
    platform: 'macOS',
  },
  {
    fileName: 'cartwheel-unreal-ue58-macos.zip',
    unrealVersion: '5.8',
    platform: 'macOS',
  },
];
